import { format } from 'date-fns';
import { SolutionSourceImageRepositoryItem } from '../types';

const getFormattedSecretExpiryDate = (secretExpiryDate?: string) => {
  if (!secretExpiryDate) {
    return undefined;
  }

  const parsedDate = new Date(secretExpiryDate);
  if (Number.isNaN(parsedDate.getTime())) {
    return secretExpiryDate;
  }

  return format(parsedDate, "yyyy-MM-dd'T'HH:mm:ss");
};

export const getSolutionSourceImageRepositoryParams = (
  params: SolutionSourceImageRepositoryItem
) => {
  const updatedParams = { ...params };
  const serverUrlValue = params.acrServerUrl || params.ecrServerUrl;
  const repoName = params.acrSourceRepoName || params.ecrSourceRepoName;
  const formattedSecretExpiryDate = getFormattedSecretExpiryDate(
    updatedParams.secretExpiryDate
  );

  if (formattedSecretExpiryDate) {
    updatedParams.secretExpiryDate = formattedSecretExpiryDate;
  }

  delete updatedParams.acrServerUrl;
  delete updatedParams.ecrServerUrl;

  if (updatedParams.containerRepositoryType === '0') {
    return {
      sourceImageRepoName: repoName,
      containerRepositoryType: Number(updatedParams.containerRepositoryType),
      serverUrl: serverUrlValue,
      userName: updatedParams.sourcePullSecretUserName,
      ImagePullSecret: updatedParams.sourcePullSecretPassword,
      secretExpiryDate: updatedParams.secretExpiryDate,
      AcrClientId: updatedParams.acrClientId,
      AcrClientSecret: updatedParams.acrClientSecretName,
    };
  }

  return {
    sourceImageRepoName: repoName,
    serverUrl: serverUrlValue,
    containerRepositoryType: Number(updatedParams.containerRepositoryType),
    EcrAccesKey: updatedParams.ecrAccesKey,
    ecrRegionEndpoint: updatedParams.ecrRegionEndpoint,
    ecrSecretKey: updatedParams.ecrSecretKey,
  };
};
